export const checkIsEmailValid = (email: string) => {
  const regex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
  return regex.test(String(email).toLowerCase())
}

export const numberOnly = (value: string | number = '') => {
  return value.toString().replace(/[^0-9]/g, '')
}
